import { env } from "../env";
import { theme } from "./theme";
import { createTheme } from "@material-ui/core";
import { gql } from "@apollo/client";

export const defaultThemeCode = env.REACT_APP_THEME || "default";

const localThemes = [{ code: "default", theme: theme }];

export const getTheme = (themeCode) => {
  const requestedTheme = localThemes.find((x) => x.code === themeCode);
  if (requestedTheme) return requestedTheme.theme;

  const fallbackTheme = localThemes.find((x) => x.code === defaultThemeCode);

  return fallbackTheme.theme;
};

export const getMuiTheme = (themeCode) => {
  const theme = getTheme(themeCode);
  return createTheme(theme);
};

export const THEME_QUERY = gql`
  query tenantTheme($tenant: String!, $isPublic: Boolean!) {
    tenantTheme(tenant: $tenant, isPublic: $isPublic) {
      code
      content
    }
    languages {
      name
      code
      shortName
      culture
    }
  }
`;
